import sliceText from 'components/helpers/sliceText';

const CardDescription = ({ description, expand }) => {
  return (
    <div className="card__description">
      {expand ? (
        <>
          <h3>Descrição:</h3>
          {/* Dangerouslyset is necessarily because api send it as Html format*/}
          {description?.length > 800 ? (
            <p dangerouslySetInnerHTML={{ __html: sliceText(description, 0, 800) + '...' }}></p>
          ) : (
            <p dangerouslySetInnerHTML={{ __html: description }}></p>
          )}
        </>
      ) : (
        <>
          {description?.length > 180 ? (
            <p dangerouslySetInnerHTML={{ __html: sliceText(description, 0, 180) + '...' }}></p>
          ) : (
            <p dangerouslySetInnerHTML={{ __html: description }}></p>
          )}
        </>
      )}
    </div>
  );
};

export default CardDescription;
